// extracted by mini-css-extract-plugin
export var layoutContainer = "_e-0";
export var layoutContainerNoRounding = "_e-6";
export var layoutContainerOpen = "_e-5";
export var layoutContainerResizing = "_e-1";
export var mainContent = "_e-2";
export var resizeDivider = "_e-3";
export var slidePanel = "_e-4";